import React from 'react';
import { Text } from '@chakra-ui/layout';
import {
  Alert,
  AlertDescription,
  AlertTitle,
  Icon,
  Button as ChakraButton,
  useDisclosure,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  Drawer,
  DrawerFooter,
} from '@chakra-ui/react';
import { FaLightbulb } from 'react-icons/fa';
import { Button, Heading } from '~/components';
import { EquipmentSuggestion } from '~/pages/Portal/Contract/EquipmentSuggestion';

interface EquipmentSuggestionDialogProps {
  id_contrato: string | undefined;
}

export const EquipmentSuggestionDialog: React.FC<EquipmentSuggestionDialogProps> =
  ({ id_contrato }: EquipmentSuggestionDialogProps) => {
    const { isOpen, onOpen, onClose } = useDisclosure();

    const handleOpen = () => {
      onOpen();
    };

    const handleClose = () => {
      onClose();
    };

    return (
      <>
        <Alert
          bg="#E3ECFD"
          borderRadius="md"
          color="#000"
          fontSize="sm"
          py={1}
          px={2}
          my={2}
        >
          <AlertTitle ml={2} mr={4}>
            <Icon as={FaLightbulb} fontSize={16} />
          </AlertTitle>
          <AlertDescription>
            <Text color="black">
              Identificamos algumas sugestões de novos equipamentos para você
              levar ao seu cliente.
              <br />
              <ChakraButton
                fontSize="sm"
                variant="link"
                fontWeight="normal"
                color="#065DD0"
                style={{ fontWeight: 500 }}
                textAlign="left"
                justifyContent="normal"
                onClick={handleOpen}
              >
                Ver sugestões de novos equipamentos
              </ChakraButton>
            </Text>
          </AlertDescription>
        </Alert>
        <Drawer
          isOpen={isOpen}
          placement="right"
          onClose={handleClose}
          size="lg"
          closeOnOverlayClick={false}
        >
          <DrawerOverlay />
          <DrawerContent>
            <DrawerCloseButton />
            <DrawerHeader mb={4}>
              <Heading fontSize="xl">Sugestões de novos equipamentos</Heading>
            </DrawerHeader>

            <DrawerBody>
              {id_contrato && (
                <EquipmentSuggestion
                  id_contrato={id_contrato}
                  showPageSize
                  showAlert
                />
              )}
            </DrawerBody>
            <DrawerFooter>
              <Button variant="secondary" onClick={() => handleClose()}>
                Fechar
              </Button>
            </DrawerFooter>
          </DrawerContent>
        </Drawer>
      </>
    );
  };
